import MLayer from './MLayer.vue';

MLayer.install = (app) => {
  app.component('MLayer', MLayer);
};

export { MLayer };
